import { render, staticRenderFns } from "./Text6.vue?vue&type=template&id=455193ac&scoped=true"
import script from "./Text6.vue?vue&type=script&lang=ts"
export * from "./Text6.vue?vue&type=script&lang=ts"
import style0 from "./Text6.vue?vue&type=style&index=0&id=455193ac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "455193ac",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VRow})
